<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('listing.batchComponents.DocumentValidation.validate_document')"
        class="document-validation"
        @closed="close"
    >
        <template #default>
            <div class="dialog__default">
                <p class="typographies-paragraph-medium-regular">
                    {{
                        $l10n.__(
                            "Les documents sélectionnés vont être validés à la date d'aujourd'hui",
                        )
                    }}
                </p>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="close"
                />
                <CompassButton
                    :label="$t.__('common.actions.confirm')"
                    type="primary"
                    :loading="loading"
                    class="ml-3"
                    @click="save"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
export default {
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            loading: false,
        };
    },
    methods: {
        close() {
            this.$emit('close');
        },

        save() {
            this.loading = true;
            this.$ajax.patch(
                `/rest/documents/validate`,
                {},
                { docIds: this.rows },
                () => {
                    this.close();
                    this.loading = false;
                    Push.success(this.$l10n.__('Les documents sont en cours de validation.'));
                },
                () => {
                    this.loading = false;
                    Push.error(
                        this.$l10n.__(
                            'Les documents ne seront pas validés. Vérifier vos permissions sur ces documents.',
                        ),
                    );
                },
            );
        },
    },
};
</script>

<style lang="scss">
.document-validation {
    .dialog {
        &__default {
            padding-bottom: var(--spacing-4);
            p {
                margin: 0;
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 var(--spacing-5) var(--spacing-4);
        }
    }
}
</style>
